import React from 'react';
import { Circle } from '@mui/icons-material';
import { Box, Tooltip, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  sentiment_score: SentimentScore;
}

const SentimentScore = ({ sentiment_score }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const icon = {
    UNDEFINED: <Circle color="disabled" />,
    POSITIVE: <Circle color="success" />,
    NEGATIVE: <Circle color="error" />,
    NEUTRAL: <Circle color="warning" />,
  }[sentiment_score ?? 'UNDEFINED'];

  return (
    <Box
      sx={{
        display: 'flex',
        p: theme.spacing(1),
      }}
    >
      <Tooltip title={<Trans t={t}>{sentiment_score}</Trans>}>{icon}</Tooltip>
    </Box>
  );
};

export default SentimentScore;
